import moment from "moment";
import React, { useCallback, useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import KartiniOnboard from "../assets/images/onboarding.webp";
import CardBasic from "../components/CardBasic";
import ModalLoading from "../components/ModalLoading";
import axios from "axios";
import { GetBalance, HEADER, dataURItoBlob, sheetNotify } from "../utils/Utils";
import ButtonRequire from "../components/Button/ButtonRequire";
import _ from "lodash";
import InformationSheet from "../components/Sheet/InformationSheet";
import { Camera } from "react-camera-pro";

export default function ConfirmVoucher() {
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));
  const [imageReceipt, setImageReceipt] = useState(null);

  const webcamRef = useRef(null);
  const [showBannerCapture, setShowBannerCapture] = useState(true);

  const { state } = useLocation();
  const { detailVoucher, settingsOveride } = state ?? {};
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
    isShow: false,
  });

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  const receiptValidation = _.isEmpty(settingsOveride.receipt_validation)
    ? detailVoucher.receipt_validation === "active"
    : settingsOveride.receipt_validation === "active";

  const [aiReceiptResult, setAiReceiptResult] = useState(null);

  const capture = useCallback((e) => {
    e.stopPropagation();
    const imageSrc = webcamRef.current.takePhoto();
    // Now you have the captured image in the 'imageSrc' variable.
    // You can save, display, or process it as needed.
    setImageReceipt(imageSrc);
    // Call AI
    if (receiptValidation) {
      ReceiptDecissionByAI(imageSrc);
    }
  }, []);

  const ReceiptDecissionByAI = async (imageSrc) => {
    setShowModalLoading(true);
    try {
      const res = await axios.post(
        `https://ai.dashboard-kar-tini.com/gemini`,
        { base64: imageSrc.split(",")[1] },
        { headers: HEADER },
      );
      const receiptData = res.data.data;

      if (!_.isEmpty(receiptData)) {
        if (receiptData?.is_receipt && receiptData?.valid) {
          setAiReceiptResult(receiptData);
          sheetNotify(
            {
              title: "Receipt Successfully Detected",
              detail: `Great! Your receipt dated [${receiptData?.transaction_date}] has been successfully detected. ${receiptData?.analysis}`,
              icon: "success",
            },
            setSheetDetail,
          );
        } else {
          setImageReceipt(null);
          sheetNotify(
            {
              title: "Receipt Not Detected",
              detail: receiptData?.analysis,
            },
            setSheetDetail,
          );
        }
      }
    } catch (error) {
      console.error("Error processing receipt:", error);
      // Optionally handle the error or notify the user
    } finally {
      setShowModalLoading(false); // Always hide the loading modal
    }
  };

  async function VoucherRedeem() {
    setShowModalLoading(true);
    let attachment = "";
    if (imageReceipt) attachment = await UploadStruk();

    if (!attachment.includes("ERROR")) {
      const payload = {
        redeemer_id: detailVoucher.redeemer_id,
        outlet_kartini_id: user.outlet_kartini_id,
        nominal:
          detailVoucher.voucher_discount ??
          detailVoucher.discount ??
          detailVoucher.nominal,
        transaction_type: "Redemption",
        voucher_number_status: "redeemed",
        attachment: attachment,
        description: `Redemption ${parseInt(
          detailVoucher.voucher_discount ??
            detailVoucher.discount ??
            detailVoucher.nominal,
        )} ${user.outlet_kartini_id}`,
        project_id: detailVoucher.project_id,
        akuisisi_id: user.akuisisi_id,
        channel_id: dataOutlet.channel_id,
        ai_receipt_result: JSON.stringify(aiReceiptResult),
      };

      await RedemptionProcess(payload);
    } else {
      setMessage({
        message: `Sorry, Failed to upload receipt`,
        type: "error",
        isShow: true,
      });
    }
    setShowModalLoading(false);
  }

  const UploadStruk = async () => {
    try {
      // Base64-encoded image data
      const base64Image = imageReceipt;

      // Convert Base64 to a Blob
      const blob = dataURItoBlob(base64Image);

      // Create a File object from the Blob
      const file = new File([blob], `image.${blob.type}`, { type: blob.type });

      // Create FormData and append the File
      const formData = new FormData();
      formData.append("file", file);

      // Axios POST request
      return await axios
        .post(process.env.REACT_APP_BASE_URL_ASSET_API, formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set the content type for FormData
            "X-Kartini-Signature": "a2FydGluaUAyMDIy",
          },
        })
        .then((res) => {
          // Handle the response from the server
          return res?.data?.data?.url;
        })
        .catch((error) => {
          // Handle errors
          console.error(error);
          return `ERROR Failed to upload receipt`;
        });
    } catch (error) {
      console.error(error);
      return `ERROR Failed to upload receipt`;
    }
  };

  /**
   * Perform the redemption process for a voucher.
   *
   * This function retrieves transactions, validates the voucher, checks the balance, and processes the redemption accordingly.
   * If the balance is sufficient, the redemption is successful, otherwise, an error message is displayed.
   *
   * @param {Object} payload - The payload containing data for the redemption process.
   * @returns {Promise<void>} - A promise that resolves once the redemption process is completed.
   */
  const RedemptionProcess = async (payload) => {
    try {
      const confirmValidVoucher = await axios
        .get(
          `${process.env.REACT_APP_BASE_URL_API}/v2/collection/mitra/ewalletTransaction/data?redeemer_id=${detailVoucher.redeemer_id}`,
          { headers: HEADER },
        )
        .then((res) => _.isEmpty(res.data.data));

      if (confirmValidVoucher) {
        const balance = await GetBalance(
          dataOutlet.channel_id,
          detailVoucher.project_id,
        );

        if (balance.deposit_balance >= detailVoucher.nominal) {
          await axios.post(
            `${process.env.REACT_APP_BASE_URL_API}/mitra/ewalletTransaction`,
            payload,
            { headers: HEADER },
          );
          setMessage({
            message: "Congratulations, Voucher successfully redeemed",
            type: "success",
            isShow: true,
          });
          setTimeout(() => {
            navigate(-1);
          }, 4000);
        } else {
          setMessage({
            message: "Sorry, your deposit balance is insufficient",
            type: "error",
            isShow: true,
          });
        }
      } else {
        setMessage({
          message: "Sorry, duplicate redemption",
          type: "error",
          isShow: true,
        });
      }
    } catch (error) {
      setMessage({
        message: "Sorry, something wrong happened in redemptions",
        type: "error",
        isShow: true,
      });
    }
  };

  const BannerMessage = () => {
    let color = "";
    if (message.type == "success") {
      color = "bg-green-100 text-green-600";
    } else if (message.type == "error") {
      color = "bg-red-100 text-red-600";
    }
    return (
      <div className="mt-5">
        <div className={`${color} rounded px-3 py-2`}>
          {message.type == "success" && (
            <svg
              className="mr-2 inline h-3 w-3 flex-shrink-0 fill-current"
              viewBox="0 0 12 12"
            >
              <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
            </svg>
          )}

          <span className="text-sm">{message.message}</span>
        </div>
      </div>
    );
  };

  const isReceiptValidationDisabled = () => {
    if (showModalLoading) {
      return true;
    }
    if (step !== 3) {
      return false;
    }
    if (_.isEmpty(settingsOveride.receipt_validation)) {
      return detailVoucher.receipt_validation === "active"
        ? _.isEmpty(imageReceipt)
        : false;
    } else {
      return settingsOveride.receipt_validation === "active"
        ? _.isEmpty(imageReceipt)
        : false;
    }
  };

  return (
    <>
      {_.isEmpty(user) || _.isEmpty(dataOutlet) ? (
        <Navigate to="/signin" />
      ) : (
        <>
          <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
          />
          <div className="space-y-5 px-5 py-5">
            <div className="flex items-center justify-center">
              <div
                className={`px-1.5 ${
                  step >= 1
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                1
              </div>
              <div
                className={`h-1 w-6 ${
                  step >= 1 ? "bg-indigo-500" : "bg-gray-200"
                } `}
              ></div>
              <div
                className={`px-1.5 ${
                  step >= 2
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                2
              </div>
              <div
                className={`h-1 w-6 ${
                  step >= 3 ? "bg-indigo-500" : "bg-gray-200"
                } `}
              ></div>
              <div
                className={`px-1.5 ${
                  step >= 3
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                3
              </div>
              <div
                className={`h-1 w-6 ${
                  step >= 3 ? "bg-indigo-500" : "bg-gray-200"
                }`}
              ></div>
              <div
                className={`px-1.5 ${
                  step === 4
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                4
              </div>
            </div>
            <div>
              {step !== 3 &&
                (detailVoucher.voucher_image ? (
                  <img
                    className="h-48 w-full rounded-lg object-cover object-center shadow-sm "
                    src={detailVoucher.voucher_image ?? KartiniOnboard}
                    alt="Kartini"
                  />
                ) : (
                  <div className="flex h-48 items-center justify-center bg-gray-100">
                    Voucher image not available
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="ml-2 h-6 w-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                      />
                    </svg>
                  </div>
                ))}
            </div>
            {step === 3 && (
              <>
                {imageReceipt ? (
                  <>
                    <img
                      src={imageReceipt}
                      alt="Img"
                      className="h-auto w-full"
                    />
                    <button
                      className="btn-lg w-full bg-gray-200 text-black hover:bg-gray-300"
                      onClick={() => setImageReceipt(null)}
                      //   to="/confirm-outlet"
                    >
                      Retake
                    </button>
                  </>
                ) : (
                  <>
                    <div className="group relative flex justify-center">
                      <Camera
                        ref={webcamRef}
                        aspectRatio={3 / 4}
                        facingMode="environment"
                      />
                      {showBannerCapture && (
                        <div className="absolute bottom-2 mx-2 flex items-center justify-center text-white opacity-100 transition-opacity duration-300">
                          <div
                            className="absolute right-2 top-1"
                            onClick={() => setShowBannerCapture(false)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="h-4 w-4"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </div>
                          <p className="bg-black bg-opacity-30 px-2 text-sm">
                            Pastikan detail transaksi (kepala struk) dan list
                            pembelian produk berpromo bisa terlihat (apabila
                            struk terlalu panjang, struk bisa dilipat sehingga
                            produk promo terkait dan kepala struk dapat difoto).
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="btn-lg w-full bg-[#4CA6F8] text-white"
                      onClick={capture}
                    >
                      {/* camera iamge */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="h-5 w-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"
                        />
                      </svg>
                    </button>
                  </>
                )}
              </>
            )}
            {step === 4 && message.isShow && BannerMessage()}
            {/* Detail Voucher */}
            <CardBasic title="Detail Voucher">
              <div className="px-5 pb-1 pt-4">
                <div className="space-y-3">
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Voucher Name
                    </div>
                    <p className="text-gray-500">
                      {detailVoucher.voucher_description ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Voucher Period
                    </div>
                    <p className="text-gray-500">
                      {detailVoucher.voucher_number_start
                        ? moment(
                            detailVoucher.voucher_number_start.split(" ")[0],
                          ).format("DD-MM-yyyy")
                        : "-"}{" "}
                      ➡️{" "}
                      {detailVoucher.voucher_number_start
                        ? moment(
                            detailVoucher.voucher_number_end.split(" ")[0],
                          ).format("DD-MM-yyyy")
                        : "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Company Name
                    </div>
                    <p className="text-gray-500">
                      {detailVoucher.client_name ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">Brand</div>
                    <p className="text-gray-500">
                      {detailVoucher.brand_name ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">SKU</div>
                    <p className="text-gray-500">
                      {detailVoucher.sku_name ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Voucher Code
                    </div>
                    <p className="text-gray-500">
                      {detailVoucher.voucher_number ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Voucher Nominal
                    </div>
                    {/* TODO: Change with real value */}
                    <p className="text-gray-500">
                      {detailVoucher.voucher_discount ??
                        detailVoucher.discount ??
                        detailVoucher.nominal}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Redeemer Mobile
                    </div>
                    <p className="text-gray-500">
                      +
                      {detailVoucher.mobile.substring(
                        0,
                        detailVoucher.mobile.length - 4,
                      ) + "XXXX"}
                    </p>
                  </div>
                </div>
              </div>
            </CardBasic>

            <div className="mt-6 flex flex-col space-y-2">
              <ButtonRequire
                title={
                  step === 1
                    ? "NEXT"
                    : step === 2
                      ? "REDEEM"
                      : step === 3
                        ? "CONFIRM REDEEM"
                        : step === 4 && "BACK TO HOME"
                }
                functionState={() => {
                  if (step === 4) {
                    // navigate(-1);
                  } else if (step === 3) {
                    VoucherRedeem();
                    setStep(step + 1);
                  } else {
                    setStep(step + 1);
                  }
                }}
                isDisabled={isReceiptValidationDisabled()}
              />

              {step !== 3 && (
                <button
                  className="btn-lg w-full bg-gray-200 text-black hover:bg-gray-300"
                  onClick={() => navigate(-1)}
                  //   to="/confirm-outlet"
                >
                  CANCEL
                </button>
              )}
            </div>
          </div>
        </>
      )}
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
}
